import classNames from 'classnames';

import styles from './presentation-container.module.css';

interface PresentationContainerProps {
  className?: string;
  children?: React.ReactNode;
  fullHeight?: boolean;
}

const PresentationContainer: React.FC<PresentationContainerProps> = ({
  className,
  children,
  fullHeight = false,
}) => {
  return (
    <div
      className={classNames(
        styles.presentationContainer,
        className,
        fullHeight ? styles.fullHeight : null
      )}
    >
      {children}
    </div>
  );
};

export default PresentationContainer;
